import './bootstrap';
import 'clipboard/dist/clipboard.js';
import '~bootstrap/dist/js/bootstrap.bundle.js';
import {createApp, defineAsyncComponent} from 'vue/dist/vue.esm-bundler';

import DetermineConsumption from './tariff-calculator/DetermineConsumption.vue';
import DetermineWarmingConsumption from './tariff-calculator/DetermineWarmingConsumption.vue';
import SecondContractPartner from './tariff-calculator/SecondContractPartner.vue';
import InvoiceAddressDiffers from './tariff-calculator/InvoiceAddressDiffers.vue';
import SelectTermination from './tariff-calculator/SelectTermination.vue';
import SelectPaymentType from './tariff-calculator/SelectPaymentType.vue';
import BankAccountNameDiffers from './tariff-calculator/BankAccountNameDiffers.vue';
import CompareConditions from './tariff-calculator/CompareConditions.vue';
import SaveTariffLinkWithEMailAddress from './tariff-calculator/SaveTariffLinkWithEMailAddress.vue';
import ClipboardJS from "clipboard";

const app = createApp({});

app.component('determine-consumption', DetermineConsumption);
app.component('determine-warming-consumption', DetermineWarmingConsumption);
app.component('second-contract-partner', SecondContractPartner);
app.component('invoice-address-differs', InvoiceAddressDiffers);
app.component('select-termination', SelectTermination);
app.component('select-termination', SelectTermination);
app.component('select-payment-type', SelectPaymentType);
app.component('bank-account-name-differs', BankAccountNameDiffers);
app.component('compare-conditions', CompareConditions);
app.component('save-tariff-link-with-e-mail-address', SaveTariffLinkWithEMailAddress);

app.mount('#tariff-calculator-app');
app.mount('#intern-app');
app.mount('#vs-page');

new ClipboardJS('.vs-clipboard-btn');

import * as bootstrap from '../../node_modules/bootstrap/dist/js/bootstrap.bundle';
window.bootstrap = bootstrap;
const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl));


// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
// register Swiper custom elements
register();
